import api from '@/apis/bu/bUPlanImportAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('bUPlanImport', api);

const state = {
  ...crud.state,
  _config: {
    table: 'bu_plan_import',
    field: {
      key: 'ref_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   *
   */
  async getDataBUPlanImport(context, payload) {
    return await api.getBUPlanImport(payload || {});
  },

  insertItem(context, item) {
    context.commit('insertItem', item);
  }
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
